import React from "react";
import {
    Modal,
    ModalBody,
    Button
} from "reactstrap";


export const ExportConfirmationModal = ({sentTo, shown, onCloseRequest}) => <Modal size="md" isOpen={shown} toggle={onCloseRequest}>
    <ModalBody>
        <div className="pad-20">
            Votre demande d'export est confirm&eacute;e.<br /><br />
            Nous enverrons un email comprenant l'export d'ici quelques minutes &agrave;&nbsp;
            <b>{ sentTo && sentTo.join(", ") }</b><br /><br />
            <div className="center">
                <Button className="text-uppercase" size="" color="primary" onClick={onCloseRequest}>Fermer</Button>
            </div>
        </div>
    </ModalBody>
</Modal>;


// WEBPACK FOOTER //
// ./src/components/Operations/Export/Modal/Confirmation.js